// Maintenance Mode Configuration
export const MAINTENANCE_MODE = {
  enabled: false, // Set to true to enable maintenance mode
  message: "We're currently performing scheduled maintenance to improve your experience.",
  submessage: "Please check back in a few hours. Thank you for your patience!",
  contact: {
    email: "support@valiram.com",
    phone: "+60 3-2166 8888"
  }
};

export const countryCodeToNationality = [
  {
    code: "+1",
    flag: "🏴",
  },
  {
    code: "+91",
    flag: "🏳️",
  },
  {
    code: "+44",
    flag: "🏳️‍🌈",
  },
];

// export function getNationalityFromCountryCode(countryCode) {
//   return countryCodeToNationality[countryCode] || "Unknown"; //'Unknown' if not found
// }

export const nationalityOptions = [
  "Malaysia",
  "Singapore",
  "Thailand",
  "Vietnam",
  "Philippines",
  "Australia",
  "New Zealand",
  "Hong Kong",
  "Macau",
  "Indonesia",
];

const convertTo24HourFormat = (time) => {
  if (!time) return null;

  const match = time.match(/(\d{1,2}):(\d{2})(am|pm)?/i);
  if (!match) return time; // Return as is if format is unexpected

  let [_, hours, minutes, period] = match;
  hours = parseInt(hours, 10);

  if (period?.toLowerCase() === "pm" && hours !== 12) {
    hours += 12;
  } else if (period?.toLowerCase() === "am" && hours === 12) {
    hours = 0;
  }

  return `${hours.toString().padStart(2, "0")}:${minutes}`;
};

export const parseHours = (currentDayHours) => {
  if (!currentDayHours) return [null, null];

  let startTime, endTime;

  if (currentDayHours.includes(" - ")) {
    [startTime, endTime] = currentDayHours.split(" - ");
  } else if (currentDayHours.includes(" to ")) {
    [startTime, endTime] = currentDayHours.split(" to ");
  }

  return [convertTo24HourFormat(startTime?.trim()), convertTo24HourFormat(endTime?.trim())];
};

export function formatDateDDMMYYYY(isoString) {
  const date = new Date(isoString);
  
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  const year = date.getFullYear();

  return `${day} / ${month} / ${year}`;
}

export function formatDate(isoString) {
  const date = new Date(isoString);

  const options = { month: "short", day: "numeric", year: "numeric" };
  const formattedDate = date.toLocaleDateString("en-US", options);

  // Add "st", "nd", "rd", or "th" to the day
  const day = date.getDate();
  const suffix =
    day % 10 === 1 && day !== 11 ? "st" : day % 10 === 2 && day !== 12
      ? "nd"
      : day % 10 === 3 && day !== 13
      ? "rd"
      : "th";

  return formattedDate.replace(/\d+/, day + suffix);
}
